let language = {
    // TODO billing-method-list.controller的多语言
    "BILLING-METHOD-LIST-ADD-BUTTON": "Add new billing method",
    "BILLING-METHOD-EMPTY-TIPS-HERE":"here",
    "BILLING-METHOD-EMPTY-TIPS":"Your billing method is empty",
    "BILLING-METHOD-EMPTY-ADD-TIP":"Add new billing methods",
    "BILLING-METHOD-TABLE-TIPS-ACCOUNT":"Account",
    "BILLING-METHOD-TABLE-TIPS-BILLINGMETHOD":"Billing Method",
    "BILLING-METHOD-TABLE-TIPS-FIRSTNAME":"First Name",
    "BILLING-METHOD-TABLE-TIPS-LASTNAME":"Last Name",
    "BILLING-METHOD-TABLE-TIPS-OPERATION":"Operation",
    "BILLING-METHOD-STATUS-DEFAULT":"Default",
    "BILLING-METHOD-STATUS-BUTTON-SET-DETAULT": "Set Default",
    "BILLING-METHOD-ALERT-DELETE-CONTENT": "Are you sure to delete this billing method?",
    "BILLING-METHOD-ALERT-SET-DEFAULT-TITLE": "Set as default billing method",
    "BILLING-METHOD-ALERT-SET-DEFAULT-CONTENT": "Are you sure to set as the default billing method?",
    "BILLING-METHOD-ALERT-SET-DEFAULT-SUCCESS": "Success to set default billing method",
    "BILLING-METHOD-DELETE-TITLE": "Delete billing method",
    "BILLING-METHOD-SUCCESS-DELETE": "Success to delete billing method",
    
    "BILLING-METHOD-DELETE-ONLY-DEFAULT-METHOD": "It is the default we use to charge you for future transactions. Are you sure to delete this default billing method?",
    "BILLING-METHOD-RESET-DEFAULT-BILLING-METHOD": "The default billing method has been deleted, please add or set a default billing method.",
    
    // 
    "BILLING-METHOD-ADD-MANUALLY": "Add manually",
    "BILLING-METHOD-IMPORT-FROM-ADDRESS-BOOK": "Import from address book",
    "BILLING-METHOD-TITLE": "Billing Method",
    "BILLING-METHOD-INFO-TITLE": "Billing Info",
    "BILLING-METHOD-SET-AS-PRIMARY": "Set as account primary billing method",
    "BILLING-METHOD-ADD-BTN": "Add",
    "BILLING-METHOD-PAYPAL-TYPE": "Paypal",
    
    "BILLING-METHOD-ADD-FAIL-TITLE": "Add Failed",
    "BILLING-METHOD-ALREADY-BEEN-ADD": "This billing method has already been added, please do not add it again.",
    
    // 默认支付方式删除失败
    "BILLING-METHOD-DELETE-FAIL-TITLE": "Delete Failed",
    "BILLING-METHOD-DELETE-FAIL-REASON1": "The billing method has been associated with auto combine order."
};

export { language }